import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';

const CGVPage = () => {
  return (
    <>
      <SEO
        title="Conditions Générales d'Abonnement — CarMaintenance"
        description="Conditions générales de l'abonnement CarMaintenance : durée, éligibilité, prestations couvertes (S, M, L), exclusions, kilométrage, résiliation et fin d'abonnement."
        path="/cgv"
      />
      <PageHero
        title="Conditions Générales d'Abonnement"
        subtitle="Édition 06.25"
      />
      <div className="bg-gradient-to-b from-gray-50 to-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <Card className="shadow-xl">
            <CardContent className="p-8 lg:p-12 space-y-8">
            
            {/* Durée */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Durée de l'abonnement</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                L'abonnement prend effet à compter de sa souscription pour une durée fixe indiquée ci-dessous. 
                Il est renouvelé automatiquement pour cette même durée, sauf résiliation au moins deux mois avant 
                la date d'échéance.
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Abonnement S</strong> : 12 mois</li>
                <li><strong>Abonnement M</strong> : 24 mois</li>
                <li><strong>Abonnement L</strong> : 24 mois</li>
              </ul>
            </section>

            {/* Conditions */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Conditions d'abonnement</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Lors de la souscription, le véhicule doit respecter les limites d'âge et de kilométrage suivantes :
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li><strong>Abonnement S</strong> : jusqu'à 20 ans et/ou 180 000 km</li>
                <li><strong>Abonnement M</strong> : jusqu'à 16 ans et/ou 150 000 km</li>
                <li><strong>Abonnement L</strong> : jusqu'à 16 ans et/ou 150 000 km</li>
              </ul>
              <p className="text-gray-700 mb-4 leading-relaxed">
                CarMaintenance se réserve le droit de contrôler l'état du véhicule avant l'activation de l'abonnement.
              </p>
              
              <p className="text-gray-700 mb-2 font-semibold">En cas de non-paiement :</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Après 15 jours de retard, des frais de 20 CHF seront facturés.</li>
                <li>Après 2 mois de retard, le montant total restant dû sera signalé à l'office des poursuites. 
                    La couverture reste active, mais aucune réparation ne sera effectuée tant que le client n'aura 
                    pas régularisé sa situation.</li>
              </ul>
              
              <p className="text-gray-700 leading-relaxed">
                Si une panne ou un défaut est détecté lors de l'inspection initiale, les réparations restent à la 
                charge du propriétaire avant la validation du contrat. Une offre de réparation à prix réduit peut 
                être proposée.
              </p>
            </section>

            {/* Exclusions */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Exclusions des prestations de l'abonnement</h2>
              <p className="text-gray-700 mb-3 leading-relaxed">
                Les cas suivants ne sont pas couverts par l'abonnement :
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Véhicules modifiés au niveau du moteur ou de la boîte de vitesses</li>
                <li>Véhicules utilisés pour la location ou le transport rémunéré de personnes</li>
                <li>Véhicules parcourant plus de 25 000 km/an sans payer un supplément</li>
                <li>Véhicules ayant participé à des compétitions ou à des activités comme le drift</li>
                <li>Mauvaise utilisation, surcharge du véhicule ou modification non homologuée</li>
                <li>Entretien non conforme ou dépassé de plus de 2 500 km selon le plan constructeur</li>
                <li>Les véhicules électriques</li>
                <li>Les véhicules du groupe Land Rover ainsi que les Jaguar</li>
              </ul>
              <p className="text-gray-700 mt-4 leading-relaxed">
                L'abonné doit fournir des justificatifs d'entretien pour demander une réparation.
              </p>
            </section>

            {/* Majoration */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Majoration pour véhicules puissants</h2>
              <p className="text-gray-700 mb-3 leading-relaxed">
                Une majoration de 30 % s'applique aux véhicules dépassant les seuils suivants :
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>190 CV pour 1 500 cm³</li>
                <li>280 CV pour 2 000 cm³</li>
                <li>390 CV pour 3 000 cm³</li>
              </ul>
              <p className="text-gray-700 mb-2 leading-relaxed">
                Pour les véhicules de 2000 cm³ dépassant 340cv, une majoration supplémentaire de 30% est appliquée.
              </p>
              <p className="text-gray-700 leading-relaxed">
                <strong>Les véhicules de plus de 500 CV ne sont pas couverts.</strong>
              </p>
            </section>

            {/* Utilisation */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Utilisation des prestations</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Un garage partenaire est attribué dans un rayon maximal de 30 km du domicile. 
                Toute intervention doit être coordonnée avec CarMaintenance.
              </p>
              
              <p className="text-gray-700 mb-2 font-semibold">En cas de panne :</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Les réparations sont effectuées sous 48 heures ouvrables, ou sous 14 jours si des pièces 
                    sont indisponibles.</li>
                <li>Un véhicule de prêt est fourni si ce délai est dépassé pour cause de surcharge.</li>
                <li>Les pannes à l'étranger sont couvertes jusqu'à 1 000 CHF en cas de décision de réparation 
                    sur place de l'assureur, en cas de rapatriement, la réparation doit se faire chez un partenaire 
                    CarMaintenance.</li>
              </ul>
              
              <p className="text-gray-700 leading-relaxed">
                Avant tout voyage, l'abonné doit effectuer les entretiens nécessaires pour éviter toute exclusion 
                de couverture.
              </p>
            </section>

            {/* Prestations par abonnement */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Prestations selon le niveau d'abonnement</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Une franchise est applicable pour chaque panne survenant durant la période de couverture. Le montant 
                de cette franchise est sélectionné par le client lors de la souscription du contrat et peut varier entre 
                CHF 0.- et CHF 500.- par panne.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                En cas de panne non couverte par l'abonnement, la réparation reste à la charge du client. Toutefois, 
                celui-ci bénéficie d'un tarif préférentiel grâce à notre réseau de partenaires agréés.
              </p>

              {/* Abonnement S */}
              <div className="bg-gray-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Abonnement S couvre :</h3>
                
                <h4 className="font-semibold text-gray-800 mt-4 mb-2">Moteur (essence et diesel) :</h4>
                <p className="text-gray-700 text-sm leading-relaxed mb-2">
                  Sont prises en charge toutes les pièces non électriques du moteur qui sont entièrement montées à 
                  l'intérieur.
                </p>
                <p className="text-gray-700 text-sm leading-relaxed">
                  <strong>Pièces couvertes :</strong> couvercle de soupape, carter d'arbre à cames, dispositif de 
                  réglage d'arbre à cames, commande de soupape électrohydraulique, culasse, joint de culasse, 
                  bloc-cylindres, carter d'huile, courroie de distribution (courroie crantée) y compris galet tendeur 
                  et de détournement, chaîne de distribution y compris guide, roue dentée, tendeur de chaîne de 
                  distribution, boîtier de filtre à huile, séparateur d'huile, bride de filtre à huile, pressostat 
                  d'huile.
                </p>

                <h4 className="font-semibold text-gray-800 mt-4 mb-2">Boîte à vitesses (manuelle, automatique, semi-automatique) :</h4>
                <p className="text-gray-700 text-sm leading-relaxed mb-2">
                  Sont prises en charge toutes les pièces non-électriques de la boîte à vitesses qui sont entièrement 
                  montées à l'intérieur.
                </p>
                <p className="text-gray-700 text-sm leading-relaxed">
                  <strong>Pièces couvertes :</strong> carter de boîte de vitesses, carter d'huile de boîte à vitesses, 
                  coffret électrique de boîte automatique, module capteur.
                </p>

                <h4 className="font-semibold text-gray-800 mt-4 mb-2">Boîte de transfert :</h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  <strong>Pièces couvertes :</strong> bride d'entraînement, carter de boîte de transfert, pièces 
                  internes de la boîte de transfert.
                </p>
              </div>

              {/* Abonnement M */}
              <div className="bg-gray-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Abonnement M couvre en plus :</h3>
                
                <div className="space-y-4 text-sm">
                  <div>
                    <h4 className="font-semibold text-gray-800">Transmission</h4>
                    <p className="text-gray-700">Toutes pièces non-électriques, servomoteurs, visco-coupleur, 
                    joint cardan, roulement de roue, etc.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Propulsion hybride</h4>
                    <p className="text-gray-700">Moteur électrique, calculateur batterie, chargeur embarqué, 
                    transformateur, onduleur, etc.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Direction</h4>
                    <p className="text-gray-700">Pompe direction assistée, mécanisme de direction, amortisseur, 
                    barre d'accouplement.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Système de freinage</h4>
                    <p className="text-gray-700">Unité hydraulique ABS, capteur ABS, maître-cylindre, servofrein, 
                    étriers, cylindre de freins.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Alimentation carburant & Suralimentation</h4>
                    <p className="text-gray-700">Pompe injection, turbocompresseur, pompe haute-pression, etc.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Refroidissement & Climatisation</h4>
                    <p className="text-gray-700">Ventilateur, refroidisseur moteur, pompe à eau, compresseur 
                    climatisation, condenseur, etc.</p>
                  </div>
                </div>
              </div>

              {/* Abonnement L */}
              <div className="bg-gray-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Abonnement L inclut en plus :</h3>
                
                <div className="space-y-4 text-sm">
                  <div>
                    <h4 className="font-semibold text-gray-800">Installation électrique</h4>
                    <p className="text-gray-700">Alternateur, démarreur, contacteur d'allumage, bobine, capteurs, 
                    unité de contrôle moteur et boîte.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Protection des occupants</h4>
                    <p className="text-gray-700">Calculateur airbag, capteur collision, prétensionneurs ceintures, 
                    capteur pression pneus, alerte collision.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Électronique de confort</h4>
                    <p className="text-gray-700">Lève-vitres, toit ouvrant, verrouillage centralisé (moteurs et 
                    calculateurs).</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800">Pièces d'usure</h4>
                    <p className="text-gray-700"><strong>Freins :</strong> disques, tambours, plaquettes, témoins 
                    d'usure.</p>
                    <p className="text-gray-700"><strong>Embrayage :</strong> butée, mécanisme, disques.</p>
                    <p className="text-gray-700"><strong>Suspension :</strong> amortisseurs, rotules, silentblocs.</p>
                  </div>
                </div>
              </div>

              {/* Exclusions */}
              <div className="bg-red-50 border border-red-200 p-6 rounded-lg">
                <h3 className="text-xl font-bold text-red-900 mb-3">Pièces NON prises en charge :</h3>
                <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
                  <li><strong>Châssis :</strong> Peinture, charnières, câbles, carrosserie, joints, plastiques, chrome.</li>
                  <li><strong>Superstructures :</strong> Camping-car, ponts de chargement, attelage.</li>
                  <li><strong>Capote, toit ouvrant :</strong> Seuls éléments électriques/hydrauliques (L uniquement).</li>
                  <li><strong>Échappement :</strong> Seuls collecteur, catalyseur, sondes (M/L). Silencieux exclus.</li>
                  <li><strong>Intérieur :</strong> Sièges, tapis, tableau de bord, habillage, pare-soleil.</li>
                  <li><strong>Multimédia :</strong> Radio, CD, navigation, écrans, antennes, téléphone.</li>
                  <li><strong>Caméras & Assistance conduite :</strong> Capteurs PDC, régulateur adaptatif, laser.</li>
                  <li><strong>Éclairage :</strong> Boîtiers phares, lentilles, ampoules, technologie laser.</li>
                  <li><strong>Motorisation gaz (CNG) :</strong> Non couvert.</li>
                  <li><strong>Autres :</strong> Jantes, pneus, installations solaires.</li>
                </ul>
              </div>
            </section>

            {/* Fin abonnement */}
            <section>
              <h2 className="text-2xl font-bold text-[#52a675] mb-4">Fin de l'abonnement</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                CarMaintenance se réserve le droit de résilier l'abonnement à tout moment, tout en maintenant les 
                prestations couvertes jusqu'à la date effective de résiliation.
              </p>
              
              <p className="text-gray-700 mb-2 font-semibold">Durées d'abonnement :</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Abonnement S : 12 mois</li>
                <li>Abonnement M : 24 mois</li>
                <li>Abonnement L : 24 mois</li>
              </ul>
              
              <p className="text-gray-700 mb-4 leading-relaxed">
                À l'issue de la période d'abonnement, celui-ci est automatiquement renouvelé pour une durée identique, 
                sauf résiliation effectuée au plus tard deux mois avant la date d'échéance.
              </p>

              <p className="text-gray-700 mb-2 font-semibold">Kilométrage maximal :</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Abonnement S : 250 000 km</li>
                <li>Abonnements M et L : 200 000 km</li>
              </ul>

              <p className="text-gray-700 mb-4 leading-relaxed">
                L'abonné est tenu d'informer CarMaintenance dès le franchissement de ce seuil. Si le kilométrage est 
                dépassé alors que le contrat est encore en cours, l'abonné devra s'acquitter de 50% du montant des 
                obligations restantes.
              </p>

              <p className="text-gray-700 mb-2 font-semibold">Cas particuliers :</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Sinistre total :</strong> Fournir preuve d'accident + nouvelle carte grise pour mise à 
                    jour du contrat.</li>
                <li><strong>Déménagement à l'étranger :</strong> Informer CarMaintenance sous 30 jours avec justificatif 
                    et procéder à la résiliation.</li>
                <li><strong>Vente du véhicule :</strong> Transférer l'abonnement au nouveau propriétaire OU transmettre 
                    la carte grise du nouveau véhicule pour mise à jour.</li>
              </ul>
            </section>

          </CardContent>
        </Card>

        <div className="text-center mt-8 text-gray-600">
          <p>Pour toute question, contactez-nous à <a href="mailto:info@car-main.ch" className="text-[#52a675] underline">info@car-main.ch</a></p>
        </div>
        </div>
      </div>
    </>
  );
};

export default CGVPage;
